import { QueryClient, MutationCache } from '@tanstack/react-query';
import { message } from 'antd';
import type { AppError } from './api-error';

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      const appError = error as AppError;
      message.error(appError.message ?? 'Something went wrong');
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
